function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var OnePlayerGameTemplate = require('../../lib/templates/oneplayer-gametemplate');
var BeleagueredGameRulesTemplate = require('./lib/beleaguered-game-rules.template');
var htmlTemplate = require('./lib/game-html.template');
var CardStack = require('../../lib/saito/ui/game-cardstack/game-cardstack');

//////////////////
// CONSTRUCTOR  //
//////////////////
var Beleaguered = /*#__PURE__*/function (_OnePlayerGameTemplat) {
  function Beleaguered(app) {
    var _this;
    _classCallCheck(this, Beleaguered);
    _this = _callSuper(this, Beleaguered, [app]);

    // show status and options in the sidebar, not floating over the board
    _this.hud.container = '.logobox';
    _this.name = 'Beleaguered';
    _this.gamename = 'Beleaguered Castle';
    _this.slug = 'beleaguered';
    _this.description = 'Stack all cards by suit from aces to kings to win this game';
    _this.categories = 'Games Cardgame One-player';
    _this.publisher_message = 'created by Pawel (twitter: @PawelPawlak14) with contributions from Saito team. Feel free to pm me with any suggestions/feedback';
    _this.animationSpeed = 700;
    _this.undoAnimationSpeed = Math.max(70, Math.round(_this.animationSpeed * 0.1));
    _this.card_img_dir = '/beleaguered/img/cards';
    _this.app = app;
    _this.status = 'beta';
    _this["class"] = 'app';
    _this.stacks = ['l1', 'm1', 'r1', 'l2', 'm2', 'r2', 'l3', 'm3', 'r3', 'l4', 'm4', 'r4'];
    _this.social.creator = 'Pawel Pawlak';
    _this.social.twitter = '@PawelPawlak14';
    return _this;
  }
  _inherits(Beleaguered, _OnePlayerGameTemplat);
  return _createClass(Beleaguered, [{
    key: "returnGameRulesHTML",
    value: function returnGameRulesHTML() {
      return BeleagueredGameRulesTemplate(this.app, this);
    }
  }, {
    key: "initializeGame",
    value: function initializeGame(game_id) {
      if (!this.game.state) {
        console.log('******Generating the Game******');
        this.game.state = this.returnState();
        this.game.queue = [];
        this.game.queue.push('round');
      }
      this.game.queue.push('READY');
      if (this.browser_active) {
        $('.slot').css('min-height', $('.card').css('min-height'));
      }
    }
  }, {
    key: "newRound",
    value: function newRound() {
      //Set up queue
      this.game.queue = [];
      this.game.queue.push('play');
      this.game.queue.push('DEAL\t1\t1\t48');
      this.game.queue.push('SHUFFLE\t1\t1');
      this.game.queue.push('DECK\t1\t' + JSON.stringify(this.returnDeck()));

      //Clear board
      this.game.board = {};
      var _iterator = _createForOfIteratorHelper(this.stacks),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var slot = _step.value;
          this.cardStacks[slot].clear();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _this2 = this;
        var dynamic_card_size, _iterator2, _step2, slot;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(!this.browser_active || !this.app.BROWSER || this.initialize_game_run)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return this.injectGameHTML(htmlTemplate());
            case 2:
              _context.n = 3;
              return _superPropGet(Beleaguered, "render", this, 3)([app]);
            case 3:
              //
              // ADD MENU
              //
              this.menu.addMenuOption('game-game', 'Game');
              this.menu.addSubMenuOption('game-game', {
                text: 'Start New Game',
                id: 'game-new',
                "class": 'game-new',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.prependMove('lose');
                  game_mod.endTurn();
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'How to Play',
                id: 'game-intro',
                "class": 'game-intro',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.overlay.showClosable(game_mod.returnGameRulesHTML());
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Stats',
                id: 'game-stats',
                "class": 'game-stats',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.overlay.showClosable(game_mod.returnStatsHTML());
                }
              });
              this.menu.addChatMenu();
              this.menu.render();

              //Check screen dimensions
              dynamic_card_size = Math.min(120, window.innerWidth / 5, window.innerHeight * 0.14);
              this.cardStacks = {};
              _iterator2 = _createForOfIteratorHelper(this.stacks);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  slot = _step2.value;
                  this.cardStacks[slot] = new CardStack(app, this, slot);
                  this.cardStacks[slot].card_width = Math.ceil(dynamic_card_size);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              this.setUpStacks();
              document.addEventListener('keydown', function (e) {
                if (e.ctrlKey && e.key === 'z') {
                  var _this2$moves;
                  if ((_this2$moves = _this2.moves) !== null && _this2$moves !== void 0 && _this2$moves.length) {
                    _this2.undoMove();
                  }
                }
              });
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "setUpStacks",
    value: function setUpStacks() {
      for (var i = 1; i <= 4; i++) {
        this.cardStacks['l' + i].orientation = 'left';
        this.cardStacks['r' + i].orientation = 'right';
        this.cardStacks['m' + i].orientation = 'center';
      }
    }
  }, {
    key: "removeEvents",
    value: function removeEvents() {
      var _iterator3 = _createForOfIteratorHelper(this.stacks),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var i = _step3.value;
          this.cardStacks[i].removeFilter();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "attachEventsToBoard",
    value: function attachEventsToBoard() {
      var _this3 = this;
      var canMoveCard = function canMoveCard(card_index, stack) {
        //You can't select a card that doesn't exist
        if (card_index == -1) {
          return false;
        }
        var card = stack.cards[card_index];
        var beleaguered_self = stack.mod;
        var suit = card[0];
        var number = parseInt(card.slice(1));

        //You can't move cards from the center
        if (stack.name[0] == 'm') {
          return false;
        }
        for (var st in beleaguered_self.game.board) {
          //You can move any card to an empty space
          if (beleaguered_self.game.board[st].length == 0) {
            return true;
          }
          var top_card = beleaguered_self.game.board[st].slice(-1)[0];
          var top_suit = top_card[0];
          var top_number = parseInt(top_card.slice(1));
          if (st[0] == 'm') {
            //Count up in the middle, suits must match
            if (suit == top_suit && number == top_number + 1) {
              return true;
            }
          } else {
            //Count down on the sides, suits can mismatch
            if (number + 1 == top_number) {
              return true;
            }
          }
        }
        return false;
      };
      var selectCard = function selectCard(activated_card_stack, card_index) {
        var game_self = activated_card_stack.mod;
        game_self.selected = activated_card_stack.cards[card_index];
        $('.gameboard').addClass('selected_state');
        var _iterator4 = _createForOfIteratorHelper(game_self.stacks),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var slot = _step4.value;
            ////////////////////////
            // Move Card!
            ///////////////////////
            game_self.cardStacks[slot].applyFilter(canPlaceCard, /*#__PURE__*/function () {
              var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(target_card_stack) {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      game_self.prependMove("move\t".concat(game_self.selected, "\t").concat(activated_card_stack.name, "\t").concat(target_card_stack.name));
                      _context2.n = 1;
                      return game_self.moveCard(game_self.selected, activated_card_stack.name, target_card_stack.name);
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              }));
              return function (_x2) {
                return _ref.apply(this, arguments);
              };
            }());
          }

          //Clicking on the same stack will unselect the card
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        activated_card_stack.applyFilter(function () {
          return true;
        }, returnCard);
        activated_card_stack.markSelected(card_index);
      };
      var canPlaceCard = function canPlaceCard(card_index, stack) {
        //Can always place on an empty slot
        if (card_index === -1) {
          return true;
        }
        var card = stack.cards[card_index];
        var beleaguered_self = stack.mod;
        var moving_card = beleaguered_self.selected;
        var moving_card_suit = moving_card[0];
        var moving_card_number = parseInt(moving_card.slice(1));
        var suit = card[0];
        var number = parseInt(card.slice(1));
        if (stack.name[0] == 'm') {
          if (moving_card_suit === suit && number + 1 === moving_card_number) {
            return true;
          }
        } else {
          if (moving_card_number + 1 == number) {
            return true;
          }
        }
        return false;
      };
      var returnCard = function returnCard() {
        activateCards();
      };
      var activateCards = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
          var c, success, _iterator5, _step5, slot, _c;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                if (!(_this3.game.board['m1'].length + _this3.game.board['m2'].length + _this3.game.board['m3'].length + _this3.game.board['m4'].length == 52)) {
                  _context3.n = 2;
                  break;
                }
                _this3.game.status = 'You Win';
                _this3.hud.updateStatus(_this3.game.status);
                _this3.hud.updateMenu([]);
                _this3.hud.updateCards([]);
                _context3.n = 1;
                return sconfirm('You win! Start new Game?');
              case 1:
                c = _context3.v;
                if (c) {
                  _this3.prependMove('win');
                  _this3.endTurn();
                }
                return _context3.a(2);
              case 2:
                //
                // Activate events always starts without a selected card
                //
                success = 0;
                $('.gameboard').removeClass('selected_state');
                _iterator5 = _createForOfIteratorHelper(_this3.stacks);
                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    slot = _step5.value;
                    success += _this3.cardStacks[slot].applyFilter(canMoveCard, selectCard);
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
                if (success) {
                  _context3.n = 4;
                  break;
                }
                _context3.n = 3;
                return sconfirm("No more moves. Start new Game?");
              case 3:
                _c = _context3.v;
                if (_c) {
                  _this3.game.status = 'Game Over';
                  _this3.hud.updateStatus(_this3.game.status);
                  _this3.hud.updateMenu([]);
                  _this3.hud.updateCards([]);
                  _this3.prependMove('lose');
                  _this3.endTurn();
                }
                return _context3.a(2);
              case 4:
                _this3.displayUserInterface();
              case 5:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function activateCards() {
          return _ref2.apply(this, arguments);
        };
      }();
      activateCards();
    }
  }, {
    key: "moveCard",
    value: function () {
      var _moveCard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(card, source_stack, target_stack) {
        var _this4 = this;
        var options,
          original_animation_speed,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              options = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : {};
              console.log("Move ".concat(card, " from ").concat(source_stack, " to ").concat(target_stack));

              //Update Internal Game Logic
              this.game.board[source_stack].pop();
              this.game.board[target_stack].push(card);
              this.selected = '';
              this.removeEvents();
              original_animation_speed = this.animationSpeed;
              if (options.animationSpeed) {
                this.animationSpeed = options.animationSpeed;
              }
              this.moveGameElement(this.copyGameElement(this.cardStacks[source_stack].getTopCardElement().children[0]), this.cardStacks[target_stack].getTopCardElement(), {
                resize: 1
              }, function () {
                $('.animated_elem').remove();
                _this4.cardStacks[source_stack].pop();
                _this4.cardStacks[target_stack].push(card);
                _this4.attachEventsToBoard();
                console.log('Finished animating');
              });
              this.animationSpeed = original_animation_speed;
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function moveCard(_x3, _x4, _x5) {
        return _moveCard.apply(this, arguments);
      }
      return moveCard;
    }() /* Copy hand into board*/
  }, {
    key: "handToBoard",
    value: function () {
      var _handToBoard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _iterator6, _step6, _i, _iterator7, _step7, slot, indexCt, j, i, card, _iterator8, _step8, _slot, _iterator9, _step9, _card, _t, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _iterator6 = _createForOfIteratorHelper(this.stacks);
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  _i = _step6.value;
                  this.cardStacks[_i].render();
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
              if (!(!('board' in this.game) || Object.keys(this.game.board).length != this.stacks.length)) {
                _context5.n = 8;
                break;
              }
              this.game.board = {};
              _iterator7 = _createForOfIteratorHelper(this.stacks);
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  slot = _step7.value;
                  this.game.board[slot] = [];
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              indexCt = 0;
              this.game.board['m1'] = ['C1'];
              this.game.board['m2'] = ['D1'];
              this.game.board['m3'] = ['H1'];
              this.game.board['m4'] = ['S1'];
              this.cardStacks['m1'].push('C1');
              this.cardStacks['m2'].push('D1');
              this.cardStacks['m3'].push('H1');
              this.cardStacks['m4'].push('S1');
              j = 0;
            case 1:
              if (!(j < 6)) {
                _context5.n = 7;
                break;
              }
              i = 1;
            case 2:
              if (!(i <= 4)) {
                _context5.n = 6;
                break;
              }
              card = this.game.deck[0].cards[this.game.deck[0].hand[indexCt++]];
              this.game.board["l".concat(i)].push(card);
              _context5.n = 3;
              return this.timeout(75);
            case 3:
              this.cardStacks["l".concat(i)].push(card);
              card = this.game.deck[0].cards[this.game.deck[0].hand[indexCt++]];
              this.game.board["r".concat(i)].push(card);
              _context5.n = 4;
              return this.timeout(75);
            case 4:
              this.cardStacks["r".concat(i)].push(card);
            case 5:
              i++;
              _context5.n = 2;
              break;
            case 6:
              j++;
              _context5.n = 1;
              break;
            case 7:
              _context5.n = 24;
              break;
            case 8:
              _iterator8 = _createForOfIteratorHelper(this.stacks);
              _context5.p = 9;
              _iterator8.s();
            case 10:
              if ((_step8 = _iterator8.n()).done) {
                _context5.n = 21;
                break;
              }
              _slot = _step8.value;
              if (this.cardStacks[_slot].initialized) {
                _context5.n = 19;
                break;
              }
              _iterator9 = _createForOfIteratorHelper(this.game.board[_slot]);
              _context5.p = 11;
              _iterator9.s();
            case 12:
              if ((_step9 = _iterator9.n()).done) {
                _context5.n = 15;
                break;
              }
              _card = _step9.value;
              _context5.n = 13;
              return this.timeout(15);
            case 13:
              this.cardStacks[_slot].push(_card);
            case 14:
              _context5.n = 12;
              break;
            case 15:
              _context5.n = 17;
              break;
            case 16:
              _context5.p = 16;
              _t = _context5.v;
              _iterator9.e(_t);
            case 17:
              _context5.p = 17;
              _iterator9.f();
              return _context5.f(17);
            case 18:
              this.cardStacks[_slot].initialized = true;
              _context5.n = 20;
              break;
            case 19:
              console.log('********************');
              console.log('Oh no, the cardstack is already initialize');
              console.log('********************');
            case 20:
              _context5.n = 10;
              break;
            case 21:
              _context5.n = 23;
              break;
            case 22:
              _context5.p = 22;
              _t2 = _context5.v;
              _iterator8.e(_t2);
            case 23:
              _context5.p = 23;
              _iterator8.f();
              return _context5.f(23);
            case 24:
              this.selected = '';
              this.displayBoard();
            case 25:
              return _context5.a(2);
          }
        }, _callee5, this, [[11, 16, 17, 18], [9, 22, 23, 24]]);
      }));
      function handToBoard() {
        return _handToBoard.apply(this, arguments);
      }
      return handToBoard;
    }()
  }, {
    key: "parseIndex",
    value: function parseIndex(slot) {
      var coords = slot.split('_');
      var x = coords[0].replace('row', '');
      var y = coords[1].replace('slot', '');
      return 10 * (parseInt(x) - 1) + parseInt(y) - 1;
    }
  }, {
    key: "handleGameLoop",
    value: function () {
      var _handleGameLoop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var msg,
          qe,
          mv,
          shd_continue,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              msg = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : null;
              this.saveGame(this.game.id);
              ///////////
              // QUEUE //
              ///////////
              if (!(this.game.queue.length > 0)) {
                _context6.n = 2;
                break;
              }
              qe = this.game.queue.length - 1;
              mv = this.game.queue[qe].split('\t');
              shd_continue = 1;
              if (mv[0] === 'round') {
                this.newRound();
              }
              if (mv[0] === 'win') {
                this.game.state.session.round++;
                this.game.state.session.wins++;
                this.game.queue.push('round');
                this.game.queue.push("ROUNDOVER\t".concat(JSON.stringify([this.publicKey]), "\t").concat(JSON.stringify([])));
              }
              if (mv[0] === 'lose') {
                this.game.state.session.round++;
                this.game.state.session.losses++;
                this.game.queue.push('round');
                this.game.queue.push("ROUNDOVER\t".concat(JSON.stringify([]), "\t").concat(JSON.stringify([this.publicKey])));
              }
              if (!(mv[0] === 'play')) {
                _context6.n = 1;
                break;
              }
              //this.game.queue.splice(qe, 1);
              if (this.browser_active) {
                this.handToBoard();
                this.displayUserInterface();
              }
              return _context6.a(2, 0);
            case 1:
              if (mv[0] === 'move') {
                this.game.queue.splice(qe, 1);
              }
            case 2:
              return _context6.a(2, 1);
          }
        }, _callee6, this);
      }));
      function handleGameLoop() {
        return _handleGameLoop.apply(this, arguments);
      }
      return handleGameLoop;
    }()
  }, {
    key: "displayBoard",
    value: function displayBoard() {
      if (this.browser_active == 0) {
        return;
      }
      var _iterator0 = _createForOfIteratorHelper(this.stacks),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var i = _step0.value;
          this.cardStacks[i].render();
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
      this.attachEventsToBoard();
    }

    /*
    no status atm, but this is to update the hud
    */
  }, {
    key: "displayUserInterface",
    value: function displayUserInterface() {
      var _this5 = this;
      var html = "<div class=\"hidable\">Place all cards ascending by number on their suit stacks to win the game.</div>\n      <div class=\"hidable\">Cards can be moved around on higher cards on the side stacks regardless of their suit. \n      Any card can be placed on the empty side stack.</div>\n      <div class=\"controls\">";
      html += "<div class=\"new_game status_option\">New Game</div>";
      if (this.moves.length > 0) {
        html += "<div class=\"restart_game status_option\">Restart</div>";
        html += "<div class=\"undo_last status_option\">Undo</div>";
      }
      html += "<div class=\"auto_solve status_option\">Auto Complete</div></div>";
      this.game.status = html;
      this.hud.updateStatus(this.game.status);
      this.hud.updateMenu([]);
      this.hud.updateCards([]);
      $('.new_game').on('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var c;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return sconfirm('Do you want to end this game and start a new one?');
            case 1:
              c = _context7.v;
              if (c) {
                _this5.prependMove('lose');
                _this5.endTurn();
              }
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      })));
      $('.undo_last').on('click', function () {
        _this5.undoMove();
      });
      $('.restart_game').on('click', function () {
        _this5.restartGame();
      });
      $('.auto_solve').on('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var success, x;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _this5.removeEvents();
              _context8.n = 1;
              return _this5.autoPlay();
            case 1:
              success = _context8.v;
              if (!success) {
                $('.auto_solve').text('No cards can castle');
                $('.auto_solve').off();
                _this5.displayBoard();
              } else {
                if (!_this5.animating_autoplay) {
                  $('.animated_elem').remove();
                  _this5.displayBoard();
                } else {
                  x = setInterval(function () {
                    if (!_this5.animating_autoplay) {
                      $('.animated_elem').remove();
                      _this5.displayBoard();
                      clearInterval(x);
                    }
                  }, 500);
                }
              }
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      })));
    }
  }, {
    key: "undoMove",
    value: function undoMove() {
      if (this.moves.length == 0) {
        return;
      }
      var mv = this.moves.shift().split('\t');
      if (mv[0] == 'move') {
        this.moveCard(mv[1], mv[3], mv[2], {
          animationSpeed: this.undoAnimationSpeed
        });
        $('.undo_last').off();
      }
    }
  }, {
    key: "restartGame",
    value: function restartGame() {
      if (this.moves.length == 0) {
        return;
      }
      this.removeEvents();
      $('.restart_game').off();
      $('.undo_last').off();
      $('.auto_solve').off();
      var moves_to_reverse = this.moves.splice(0);
      var _iterator1 = _createForOfIteratorHelper(moves_to_reverse),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var move = _step1.value;
          var mv = move.split('\t');
          if (mv[0] == 'move') {
            this.reverseMove(mv);
          }
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
      this.selected = '';
      $('.animated_elem').remove();
      var _iterator10 = _createForOfIteratorHelper(this.stacks),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var slot = _step10.value;
          this.cardStacks[slot].cards = _toConsumableArray(this.game.board[slot]);
          this.cardStacks[slot].initialized = true;
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      this.displayBoard();
      this.displayUserInterface();
    }
  }, {
    key: "reverseMove",
    value: function reverseMove(mv) {
      var card = mv[1];
      var source_stack = mv[2];
      var target_stack = mv[3];
      var moved_card = this.game.board[target_stack].pop();
      this.game.board[source_stack].push(moved_card || card);
    }
  }, {
    key: "autoPlay",
    value: function () {
      var _autoPlay = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _this6 = this;
        var source_stack, target_stack, target_card, i, top_card, _iterator11, _step11, slot, available_card, _t3;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              source_stack = '';
              target_stack = '';
              target_card = '';
              i = 1;
            case 1:
              if (!(i <= 4)) {
                _context9.n = 10;
                break;
              }
              target_stack = "m".concat(i);
              top_card = this.game.board[target_stack].slice(-1)[0];
              target_card = top_card[0] + (parseInt(top_card.slice(1)) + 1);
              _iterator11 = _createForOfIteratorHelper(this.stacks);
              _context9.p = 2;
              _iterator11.s();
            case 3:
              if ((_step11 = _iterator11.n()).done) {
                _context9.n = 5;
                break;
              }
              slot = _step11.value;
              if (!(this.game.board[slot].length > 0)) {
                _context9.n = 4;
                break;
              }
              available_card = this.game.board[slot].slice(-1)[0];
              if (!(available_card == target_card)) {
                _context9.n = 4;
                break;
              }
              source_stack = slot;
              return _context9.a(3, 5);
            case 4:
              _context9.n = 3;
              break;
            case 5:
              _context9.n = 7;
              break;
            case 6:
              _context9.p = 6;
              _t3 = _context9.v;
              _iterator11.e(_t3);
            case 7:
              _context9.p = 7;
              _iterator11.f();
              return _context9.f(7);
            case 8:
              if (!source_stack) {
                _context9.n = 9;
                break;
              }
              return _context9.a(3, 10);
            case 9:
              i++;
              _context9.n = 1;
              break;
            case 10:
              if (!source_stack) {
                _context9.n = 13;
                break;
              }
              this.prependMove("move\t".concat(target_card, "\t").concat(source_stack, "\t").concat(target_stack));
              //this.animationSpeed = 500;

              //Update Internal Game Logic
              this.game.board[source_stack].pop();
              this.game.board[target_stack].push(target_card);
              this.selected = '';
              this.animating_autoplay = true;
              this.moveGameElement(this.copyGameElement(this.cardStacks[source_stack].getTopCardElement().children[0]), "#cardstack_".concat(target_stack), {
                resize: 1,
                callback: function callback() {
                  _this6.cardStacks[source_stack].pop();
                  _this6.cardStacks[target_stack].push(target_card, false);
                }
              }, function () {
                _this6.animating_autoplay = false;
                console.log('Running callback at end of animation???');
              });
              _context9.n = 11;
              return this.timeout(200);
            case 11:
              _context9.n = 12;
              return this.autoPlay();
            case 12:
              return _context9.a(2, true);
            case 13:
              return _context9.a(2, false);
          }
        }, _callee9, this, [[2, 6, 7, 8]]);
      }));
      function autoPlay() {
        return _autoPlay.apply(this, arguments);
      }
      return autoPlay;
    }()
  }, {
    key: "returnCardImageHTML",
    value: function returnCardImageHTML(name) {
      if (name[0] == 'E') {
        return '';
      } else {
        return "<img src=\"".concat(this.card_img_dir, "/").concat(name, ".png\" />");
      }
    }
  }, {
    key: "returnDeck",
    value: function returnDeck() {
      var suits = ['S', 'C', 'H', 'D'];
      var deck = {};
      for (var i = 0; i < 4; i++) for (var j = 2; j <= 13; j++) {
        var name = suits[i] + j;
        deck[name] = name;
      }
      return deck;
    }
  }]);
}(OnePlayerGameTemplate);
module.exports = Beleaguered;